/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateStampPreviewForDocumentData } from '../../models/create-stamp-preview-for-document-data';
import { StampPreviewForDocument } from '../../models/stamp-preview-for-document';

export interface DocumentCreateStampPreviewForDocument$Params {

/**
 * GUID of the document
 */
  documentId: string;

/**
 * GUID of the stamp
 */
  stampId: string;
  
    /**
     * Create stamp preview for document data
     */
    body?: CreateStampPreviewForDocumentData
}

export function documentCreateStampPreviewForDocument(http: HttpClient, rootUrl: string, params: DocumentCreateStampPreviewForDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<StampPreviewForDocument>> {
  const rb = new RequestBuilder(rootUrl, documentCreateStampPreviewForDocument.PATH, 'post');
  if (params) {
    rb.path('documentId', params.documentId, {});
    rb.path('stampId', params.stampId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StampPreviewForDocument>;
    })
  );
}

documentCreateStampPreviewForDocument.PATH = '/document/{documentId}/stamp/{stampId}/preview';
